import React from 'react'
import { Box, Skeleton } from '@mui/material'
import styles from './LoadingNotification.module.scss'

interface LoadingNotificationProps {
  isHeader?: boolean
}

const LoadingNotification = ({ isHeader }: LoadingNotificationProps) => {
  return (
    <Box className={`${styles.container} ${isHeader ? styles.isHeader : ''}`}>
      <Skeleton 
        variant="circular" 
        width={44} 
        height={44}
        className={`${styles.avatar} ${isHeader ? styles.isHeader : ''}`}
      />
      <Box className={styles.content}>
        <Skeleton 
          variant="text" 
          width="70%" 
          height={20}
          className={`${styles.skeleton} ${isHeader ? styles.isHeader : ''}`}
        />
        <Skeleton 
          variant="text" 
          width="90%" 
          height={16}
          className={`${styles.skeleton} ${isHeader ? styles.isHeader : ''}`}
        />
        <Skeleton 
          variant="text" 
          width="30%" 
          height={14}
          className={`${styles.skeleton} ${isHeader ? styles.isHeader : ''}`}
        />
      </Box>
    </Box>
  )
}

export default LoadingNotification